import axios from 'axios';

export const getAvailableFilterValues = location => axios.get(location)
    .then(r => r.data.map(i => ({ title: i, value: i })));

export const fetchProductClass = product => axios.get('/SystemInfo/ModelStatic', { params: { product } })
    .then(r => r.data);
